import React, { useState } from 'react';
import SearchTextField from '../../../GlobalComponents/CustomComponant/SearchTextField';
import { IconButton } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import ListDynamicTable from '../../../GlobalComponents/CustomComponant/ListDynamicTable';
import ExportToExcelCustomButton from '../../../GlobalComponents/ExportToExcelButtonCustom';
import ExportToPDFCustomButton from '../../../GlobalComponents/ExportPDFfromTable';
//import {DISPLAY_PAGE_SIZE} from "../../../constants/constants";
function SearchData() {

    const [pageLoader, setPageLoader] = useState(false);
  //const [currentPage, setCurrentPage] = useState(1); // set the current page
   // const pageSize = DISPLAY_PAGE_SIZE;
   //let pageLoader="false";
let currentPage=1;
  return (
    <div> <div className="windows-header">

    <h2>Search Data</h2>
  </div>
  
  
  <div className="content">


{/*-----------------------SEARCH BOX--------------------*/}
{currentPage === 1 ? (
            <SearchTextField
              label="Search Data"
             // value={srcinddata}
              title="Search Data"
            //  onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search Data">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          {pageLoader ? (
            <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>
          ) : (
           // <ListDynamicTable
             // columns={columns}
             // columnNames={columnNames}
             // data={returnData}
             // totalRows={totalRows}
             // pageSize={pageSize}
             // currentPage={currentPage}
             // setCurrentPage={setCurrentPage}
             // onRowClick={handleRowClick}
           // />
           <div>,</div>
          )}

          {/* <div className="mb-3 container mt-2 col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              //data={reportData}
             // fileName={"Suitability"} // + ${currentPage}}
              //columns={columns}
             // columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
             // data={reportData}
             // fileName={"Suitability"}
             // columns={columns}
             // columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader="Suitability Pending List"
              disabled="true"
            />
          </div> */}




                
                
                
                </div>
  
  </div>
  )
}

export default SearchData   